export default "__VITE_ASSET__Ct48tvD2__"